export default {
      id: "main-header-bg-usage",
      viewBox: "0 0 1736 1016",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#main-header-bg",
      toString: function () {
        return this.url;
      }
    }